module.exports = __webpack_public_path__ + "media/images/icons/form_professional_step_2-cf27342019351fecc4c6224b945946bd.svg";